"use client";

import { useMediaQuery } from "./use-media-query";

/** Below this, the rail is replaced by the header + drawer. Single place to change it. */
const MOBILE_BREAKPOINT = 768;

export const useIsMobile = () => useMediaQuery(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
